<div class="starbox">
    <div class="star" *ngFor="let i of [1,2,3,4,5]">
        <div class="substar" [ngStyle]="{
            'width.%': i <= nextRating ? pointValue : ''
          }" [ngClass]="i<=rating?'w-100':''">
        </div>
    </div>
</div>